module.exports = [{
      plugin: require('/Users/NickLoeper/fisherman/fisherman-website-generator-mock/node_modules/gatsby-plugin-offline/gatsby-browser'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/NickLoeper/fisherman/fisherman-website-generator-mock/node_modules/gatsby-plugin-google-analytics/gatsby-browser'),
      options: {"plugins":[],"trackingId":"UA-115752803-4","head":true,"anonymize":true,"respectDNT":false},
    }]
